import * as React from "react";
import Grid from "@mui/material/Grid";
import { AMC_DETAILS } from "../../variable";
import styles from "../../assets/css/LeftNav.module.css";
import { ReactComponent as KfinLogo } from "../../assets/svg/KfintechNavBarLogo.svg";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

let ReportSVG, DashboardSVG, UpdatesSVG, TransactionHistory, FormsDownloadSVG;

if (AMC_DETAILS.MODE === "dark") {
  ReportSVG = require("../../assets/svg/ClientReport.svg").ReactComponent;
  DashboardSVG = require("../../assets/svg/Dashboard.svg").ReactComponent;
  UpdatesSVG = require("../../assets/svg/Updates.svg").ReactComponent;
  TransactionHistory =
    require("../../assets/svg/TransactionHistory.svg").ReactComponent;
  FormsDownloadSVG =
    require("../../assets/svg/FormsDownload.svg").ReactComponent;
} else {
  ReportSVG = require("../../assets/svg/ClientReportLight.svg").ReactComponent;
  DashboardSVG = require("../../assets/svg/DashboardLight.svg").ReactComponent;
  UpdatesSVG = require("../../assets/svg/UpdatesLight.svg").ReactComponent;
  TransactionHistory =
    require("../../assets/svg/TransactionHistoryLight.svg").ReactComponent;
  FormsDownloadSVG =
    require("../../assets/svg/FormsDownloadLight.svg").ReactComponent;
}
function LeftNav(props) {
  //console.log("let nav")

  return (
    <div style={{ paddingTop: "65px", zIndex: "2" }}>
      <Grid
        className={styles.leftNavBar}
        container
        maxWidth={"18rem"}
        minWidth={"18rem"}
        marginTop={"-63px"}
        spacing={2}
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="fixed"
      >
        {" "}
        <Grid
          item
          className={styles.leftTile}
          style={{
            paddingTop: " 40px",
            paddingLeft: "45px",
            paddingBottom: "5px",
            zIndex: "4",
          }}
        >
          <KfinLogo />
        </Grid>
        <Grid
          item
          className={
            props.page === "INV" ? styles.leftTileGolden : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/investor/dashboard"
            style={{
              textDecoration: "none",
              fontWeight: AMC_DETAILS.MODE === "dark" ? "500" : "600",
            }}
            className={styles.leftTile}
          >
            <DashboardSVG
              className={
                AMC_DETAILS.MODE === "dark" ? styles.tileSvg : styles.tileSvg2
              }
            />{" "}
            Dashboard
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "RecentTransactionInvestor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/investor/transactionHistory"
            style={{
              textDecoration: "none",
              fontWeight: AMC_DETAILS.MODE === "dark" ? "500" : "600",
            }}
            className={styles.leftTile}
          >
            <TransactionHistory
              className={
                AMC_DETAILS.MODE === "dark" ? styles.tileSvg : styles.tile2Svg2
              }
            />
            Transaction History
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "CLINV" ? styles.leftTileGolden : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/investor/reports"
            style={{
              textDecoration: "none",
              fontWeight: AMC_DETAILS.MODE === "dark" ? "500" : "600",
            }}
            className={styles.leftTile}
          >
            {
              <ReportSVG
                className={
                  AMC_DETAILS.MODE === "dark" ? styles.tileSvg : styles.tileSvg2
                }
              />
            }
            Reports
          </NavLink>
        </Grid>
        <Grid
          item
          className={
            props.page === "UpdatesAndAnnouncementsInvestor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <Grid
            item
            xs={12}
            // style={{ display: "flex", justifyContent: "space-around" }}
          >
            <NavLink
              to="/investor/updates"
              style={{
                textDecoration: "none",
                fontWeight: AMC_DETAILS.MODE === "dark" ? "500" : "600",
              }}
              className={styles.leftTile}
            >
              <UpdatesSVG
                className={
                  AMC_DETAILS.MODE === "dark" ? styles.tileSvg : styles.tileSvg2
                }
              />
              Updates &nbsp;&nbsp;&nbsp;&nbsp;
              {props.unread ? (
                <span className={styles.dot}>{props.unread}</span>
              ) : (
                <></>
              )}
            </NavLink>
          </Grid>
        </Grid>
        <Grid
          item
          className={
            props.page === "FormsAndDownloadInvestor"
              ? styles.leftTileGolden
              : styles.leftTile
          }
          // style={{ borderBottom: "solid 2px #AD9042" }}
        >
          <NavLink
            to="/investor/standardForms"
            style={{
              textDecoration: "none",
              fontWeight: AMC_DETAILS.MODE === "dark" ? "500" : "600",
            }}
            className={styles.leftTile}
          >
            <FormsDownloadSVG
              className={
                AMC_DETAILS.MODE === "dark" ? styles.tileSvg : styles.tileSvg2
              }
            />
            Standard Forms
          </NavLink>
        </Grid>
        <Grid item className={styles.lastTile}></Grid>
      </Grid>
    </div>
  );
}

const mapStatetoProps = (state) => {
  return {
    page: state.mainReducer.page,
    userDetails: state.mainReducer.userDetails,
    unread: state.mainReducer.unread,
  };
};
export default connect(mapStatetoProps)(LeftNav);
